/* eslint-disable react/display-name */
import React, { ForwardedRef, forwardRef } from 'react';

import cx from 'classnames';

import Icon from '../icons';

import styles from './fieldLabel.module.scss';

interface FieldLabelProps {
  prefixIcon?: string | React.ReactNode;
  suffixIcon?: string | React.ReactNode;
  labelText?: string;
  labelFor?: string;
  prefixIconClassName?: string;
  suffixIconClassName?: string;
  labelClassName?: string;
  isRequiredField?: boolean;
  direction?: 'ltr' | 'rtl';
}

const FieldLabel = forwardRef((props: FieldLabelProps, ref: ForwardedRef<HTMLLabelElement>) => {
  const {
    prefixIcon = '',
    suffixIcon = '',
    labelText = '',
    labelFor = '',
    prefixIconClassName = '',
    suffixIconClassName = '',
    labelClassName = '',
    isRequiredField,
    direction = 'ltr',
  } = props;

  if (!labelText) {
    return null;
  }

  return (
    <section className={cx(styles.labelComponentWrapper)}>
      <Icon
        icon={prefixIcon}
        className={cx(styles.pefixLabelComponentIcon, prefixIconClassName)}
        style={{
          marginLeft: direction === 'rtl' ? 4 : 0,
          marginRight: direction === 'ltr' ? 4 : 0,
        }}
      />
      <label htmlFor={labelFor} ref={ref} className={cx(styles.labelComponentText, labelClassName)}>
        {labelText}
        {isRequiredField && <span className={styles.required}>*</span>}
      </label>
      <Icon
        icon={suffixIcon}
        className={cx(styles.suffixLabelComponentIcon, suffixIconClassName)}
        style={{
          marginRight: direction === 'rtl' ? 4 : 0,
          marginLeft: direction === 'ltr' ? 4 : 0,
        }}
      />
    </section>
  );
});

export default FieldLabel;
